
import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, Link, Navigate } from 'react-router-dom';

import Constants from '../Constants';
import { useAuth } from '../AuthContext';

import '../App.css';

import wordmark from '../assets/menu-wordmark.png';

function LoginView() {
  const [email, setEmail] = useState(localStorage.getItem(Constants.USER_EMAIL) || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [session_expired] = useState(function() {
    const query_params = new URLSearchParams(window.location.search);
    return query_params.get('session_expired') === '1';
  });
  const navigate = useNavigate();

  const { setToken, token } = useAuth();

  if(token) {
    return <Navigate to="/dashboard" replace />;
  }

  useEffect(() => {

    // const token = localStorage.getItem(Constants.TOKEN_NAME);
    // if(success) {
    // if(token && (token != 'null')) {
    //   navigate('/');
    // }
  }, [success, navigate]);

  const handle_send = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if(!email || !password) {
      setError('All fields are required.');
      return;
    }

    try {
      const url = Constants.SERVER_URL + '/api/auth/login';
      const response = await axios.post(url, { email, password });

      const user_data = response.data;
      if(user_data && user_data.token) {      

        localStorage.setItem(Constants.TOKEN_NAME, user_data.token);
        localStorage.setItem(Constants.USER_EMAIL, email);
        localStorage.setItem(Constants.USER_ID, user_data.user_id);
        
        // setToken(response.data.token);
        // localStorage.setItem(Constants.TOKEN_NAME, response.data.token);
        setSuccess(true);
        // navigate('/');
        window.location.replace('/dashboard');
      } else {
        setError('Invalid email or password.');
      }
    } catch (error) {
        if(error.response && error.response.data && error.response.data.message) {
          setError(error.response.data.message);
          if(error.response.data.message == 'User not active'){
            setTimeout(()=>{ navigate('/plans'); }, 1500);
          }

        } else {
            setError('Failed to connect to server.');
        }
    }
  };

  const render_form_input = (controlId, label, type, placeholder, value, setter, autoComplete) => {
    return(
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setter(e.target.value)}
          autoComplete={autoComplete}
          required
        />
      </Form.Group>
    );
  };

  

  return (
    <Container fluid className='auth-container'>
      <Row className='auth-row'>
        <Col lg={4} md={6} sm={10} xs={11}>
          <Card className='auth-card'>
            <Card.Body className='auth-card-body'>
              

              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">Login successful</Alert>}
              {session_expired && !error && !success && <Alert variant="warning">Your session expired. Please log in again.</Alert>}

              <Form onSubmit={handle_send}>
                <Row className="mx-0">
                  <img src={wordmark} className="signin-logo"/>
                  <h3 className='auth-title'>Login</h3>
                </Row>
                <Row className="mx-0">
                  {render_form_input('loginEmail', 'Email address', 'email', 'Enter email', email, setEmail, 'email')}
                </Row>

                <Row className="mx-0">
                  {render_form_input('loginPassword', 'Password', 'password', 'Enter password', password, setPassword, 'off')}
                </Row>

                <div className="d-grid mt-2 form-button auth-form-button">
                  <Button variant="primary" type="submit">Login</Button>
                </div>
              </Form>

              <div className='forgot-password'>
                  <Link to="/request_password_reset" className='app-link'>
                    Forgot your password?
                  </Link>
              </div>

              <div className='forgot-password'>
                  Not registered? Sign up
                  <Link to="/plans" className='app-link app-register-link'>
                    here
                  </Link>
              </div>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default LoginView;

